import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { BASE_URL } from '@elevate-workspace/auth';
import { Home } from 'apps/RoseApp/src/app/shared/interface/home';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HomeService {
  _Baseurl=inject(BASE_URL)
_httpClient=inject(HttpClient);
  getHomeData():Observable<Home>{
    return this._httpClient.get<Home>(this._Baseurl+'api/v1/home');
  }
 
}
